<template>
  <div>
    <div class="flex flex-col justify-between mt-4">
      <div class="grow">
        <div>
          <div class="ml-3 text-sm">
            <p class="text-center text-gray-500" v-if="contractType === 'insurance'">
              J'accepte de souscrire à l'assurance et je confirme avoir lu, accepté et sauvegardé
              <a :href="marketingPage" target="_blank" class="font-medium text-primary">la notice d'information</a>
              comme conditions générales et
              <a :href="marketingPage" target="_blank" class="font-medium text-primary">le document d'information</a>
              sur le produit d'assurance. J'accepte de recevoir les informations contractuelles par voie électronique et
              de les sauvegarder sur un support durable.
            </p>
            <p class="text-center text-gray-500" v-else-if="contractType === 'warranty'">
              J'accepte de souscrire à la garantie et je confirme avoir lu, accepté et sauvegardé
              <a :href="marketingPage" target="_blank" class="font-medium text-primary">les conditions générales</a>
              du produit de garantie.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    marketingPage: String,
    contractType: String,
  },
};
</script>
